import { AdminStoresTemplate } from "../../Templates/AdminStoresTemplate";

export const AdminStores = () => {
  return <AdminStoresTemplate />;
};
